import { IEnvService } from '@/core/services/env/env-service'
import { IHttpClient } from '@/core/services/http'
import { ApiError } from '@/core/types/errors/http-error'
import { PlaceResponse } from '../types/api-responses/place'
import { PlaceModel } from '../types/models/place.model'

const GOOGLE_MAPS_ENDPOINT =
  'https://maps.googleapis.com/maps/api/place/details/json'

const REQUIRED_FIELDS = [
  'name',
  'rating',
  'reviews',
  'formatted_address',
  'photos',
  'geometry',
  'opening_hours',
] as const

export function createGetPlaceDetailsUseCase({
  envService,
  httpClient,
}: {
  envService: IEnvService
  httpClient: IHttpClient
}) {
  return async function (placeId: string) {
    const mapsApiKey = envService.get('MAPS_API_KEY')

    if (!mapsApiKey) {
      throw new ApiError('Missing MAPS_API_KEY environment variable')
    }

    try {
      const response = await httpClient.get<{ result: PlaceResponse }>(
        GOOGLE_MAPS_ENDPOINT,
        {
          params: {
            place_id: placeId,
            fields: REQUIRED_FIELDS.join(','),
            key: mapsApiKey,
          },
        },
      )

      return resolver(response.data.result)
    } catch (_) {
      return null
    }
  }
}

function resolver(place: PlaceResponse): PlaceModel {
  if (!place) return {}
  return place
}
